module.exports = __webpack_public_path__ + "static/media/ra.47ce6e77.png";